import React from "react";
import { useAarp } from "../components/hooks/useAarp";
import { useAltSupportNumber} from "../components/hooks/useAltSupportNumber";

function NeedHelp() {
  const { isAarp } = useAarp();
  const { altSupportNumber } = useAltSupportNumber();
  return (
    <section className="row">
      <div className="col-xs-12">
        <div>
          {isAarp ? (
            <>
              <h2>Need Help?</h2>
              <p>Call Optum Bank 24/7 at 1-844-458-6738</p>
              <p>
                <a href="https://myaarphsa.com/" target="_blank" rel="noreferrer">
                  myaarphsa.com
                </a>
              </p>
              <p>
                Optum Bank offers AARP Health Savings Account offered by Optum
                Bank to eligible AARP members.
              </p>
              <p>
                Optum Bank pays royalty fees to AARP for the use of its
                intellectual property. These fees are used for the general
                purposes of AARP. Provider offers are subject to change and may
                have restrictions. Please contact the provider directly for
                details.
              </p>
              <p>
                Health savings accounts (HSAs) are individual accounts offered
                or administered by Optum Bank®, Member FDIC, and are subject to
                eligibility requirements and restrictions on deposits and
                withdrawals to avoid IRS penalties. State taxes may apply. Fees
                may reduce earnings on account. The content on this website is
                not intended as legal or tax advice. Federal and state laws and
                regulations are subject to change.
              </p>
              <p>
                Mutual fund investment options are made available through the
                services of an independent investment advisor. Shares are
                offered through Charles Schwab & Co., Inc., a registered
                broker-dealer. Orders are accepted to effect transactions in
                securities only as an accommodation to HSA owners. Optum Bank is
                not a broker-dealer or registered investment advisor, and does
                not provide investment advice or research concerning securities,
                make recommendations concerning securities, or otherwise solicit
                securities transactions.
              </p>
            </>
          ) : (
            <>
              <h2>Need Help?</h2>
              <div>Call us at {altSupportNumber !== "" ? (altSupportNumber) : ('1-866-234-8913')}</div>
              <div>
                24 hours a day, 7 days a week, excluding major U.S. holidays
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default NeedHelp;
